import { isNil } from 'lodash'
import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
import activeVendors from '../../../reducer/activeVendors'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { createContent, buildContent } from '../infoWindow'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../action/infowindow-action'
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id'

const RenderPolygons = (props) => {
  const [disableObj, setDisabelObj] = useState(props.disableMapObj.disableMapObject)
  const [infowindowsState, setInfowindowsState] = useState(null)
  let { infoWindowOpenAction, infoWindow, selectedObjectId, selectedObjectIdNull } = props
  const polygonRefs = useRef({});  // Add this to track markers on the map
  let openInfoWindow = null;
  useEffect(() => {
    if (infoWindow && infoWindow.infoWindowFunction) {
      infoWindow.infoWindowFunction.close()
    }
    if (infoWindow.infoWindowFunction) {
      infoWindowOpenAction(infowindowsState)
    }
  }, [infowindowsState])

  let storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value)
  }
  useEffect(() => {
    props.polygons.forEach(polygon => {
      if (polygon.mapObj) {
        polygon.mapObj().setOptions({ clickable: props.disableMapObj.disableMapObject });
      }
    });
    setDisabelObj(props.disableMapObj.disableMapObject)
  }, [props.disableMapObj.disableMapObject, props.polygons]);
  const { expandLeftToolbar, polygons, mapReference, activeVendors, vendors, collapseLeftToolbar } = props,
    vendorPolys = activeVendors.map(id => {
      return vendors[id] && vendors[id]['objects'] && vendors[id]['objects']['polygons'] ?
        vendors[id]['objects']['polygons'].filter(poly => isNil(poly.mapObj) && !isNil(poly.geoJson)) : []
    }),
    toAdd = polygons.filter(poly => isNil(poly.mapObj)).concat(vendorPolys.flat())
  if (!isNil(mapReference) && toAdd.length > 0) {
    toAdd.forEach(polygon => {
      polygon['measureType'] = 'polygon'
      if (!polygon.geoJson) {
        return
      }

      if (!polygonRefs.current[polygon.id]) {  // Only add marker if not already on the map
      } else {
        polygonRefs.current[polygon.id].setMap(null)
        delete polygonRefs.current[polygon.id];
      }
      const geoJson = JSON.parse(polygon.geoJson),
        coords = geoJson.features[0].geometry.coordinates[0].map(coord => new google.maps.LatLng(coord[1], coord[0])),
        mappoly = new google.maps.Polygon({
          name: polygon.name,
          map: mapReference,
          path: coords,
          strokeColor: geoJson.features[0].properties.line.color
            ? geoJson.features[0].properties.line.color.length == 9
              ? '#' + geoJson.features[0].properties.line.color.substring(3, 9)
              : geoJson.features[0].properties.line.color
            : '#0009F9',
          fillColor: geoJson.features[0].properties.line.color
            ? geoJson.features[0].properties.line.color.length == 9
              ? '#' + geoJson.features[0].properties.line.color.substring(3, 9)
              : geoJson.features[0].properties.line.color
            : '#0009F9',
          strokeOpacity: 1,
          strokeWeight: 3,
          zIndex: 10,
          options: {
            draggable: false,
            clickable: true,
            cursor: 'pointer'
          }
        })
      polygon['mapObj'] = function () { return mappoly }
      mappoly.setOptions({ clickable: disableObj });
      mappoly.addListener('click', (event) => {
        selectedObjectId(polygon.id)
        const latLng = event.latLng;
        const lat = latLng.lat();
        const lng = latLng.lng();
        let infoPosition = { lat: lat, lng: lng }
        let editFunction = (infoWindow) => {
          closeFunction(infoWindow)
          // infoWindowOpenAction(null)
          collapseLeftToolbar()
          expandLeftToolbar({ dialog: 'edit', editable: polygon })
          selectedObjectIdNull()
        }

        const closeFunction = (infoWindow) => {
          openInfoWindow = infoWindow;
          openInfoWindow.close();
          // infoWindowOpenAction(null)
          setInfowindowsState(null)
          selectedObjectIdNull()
        }

        const updateInfoWindow = (value) => {
          openInfoWindow = value
        }

        const dispatchFunction = (value) => {
          storeInfoBox(value)
        }

        createContent({ shapeDetails: polygon, mapObj: mappoly, infoWindow, type: 'poly', infoPosition }, { editFunction, closeFunction, updateInfoWindow }, dispatchFunction);
      })
      polygonRefs.current[polygon.id] = mappoly;  // Track added marker by id
    })
  }
  return null
}

const mapStateToProps = state => ({
  activeVendors: state.activeVendors,
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  polygons: state.polygons,
  disableMapObj: state.disableMapObj,
  infoWindow: state.infoWindow
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  selectedObjectId: (payload) => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderPolygons)